var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var ResultImpl = /** @class */ (function () {
    function ResultImpl() {
    }
    ResultImpl.ok = function (t) {
        return new Ok(t);
    };
    ResultImpl.err = function (e) {
        return new Err(e);
    };
    // Note: This is a function. Use `if (res.isOk())`, not `if (res.isOk)`
    ResultImpl.prototype.isOk = function () {
        return this instanceof Ok;
    };
    // Note: This is a function. Use `if (res.isErr())`, not `if (res.isErr)`
    ResultImpl.prototype.isErr = function () {
        return this instanceof Err;
    };
    ResultImpl.prototype.orElse = function (defaultValue) {
        return this.isOk() ? this.value : defaultValue;
    };
    ResultImpl.prototype.andThen = function (onSuccess, onFailure) {
        var self = this.asResult();
        return self.isOk() ? onSuccess(self.value) : onFailure(self.error);
    };
    ResultImpl.prototype.getOrThrow = function () {
        var self = this.asResult();
        if (self.isErr()) {
            throw self.error;
        }
        return self.value;
    };
    ResultImpl.prototype.asResult = function () {
        // Necessary internally to tell TS that it only needs to consider Ok and Err
        return this;
    };
    return ResultImpl;
}());
export var Result = ResultImpl;
var Ok = /** @class */ (function (_super) {
    __extends(Ok, _super);
    function Ok(value) {
        var _this = _super.call(this) || this;
        _this.value = value;
        return _this;
    }
    return Ok;
}(ResultImpl));
var Err = /** @class */ (function (_super) {
    __extends(Err, _super);
    function Err(error) {
        var _this = _super.call(this) || this;
        _this.error = error;
        return _this;
    }
    return Err;
}(ResultImpl));
